<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <b-badge class="bg-blue">
            <i class="fa fa-file mr-2"></i>
            Change in Directorship
          </b-badge>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <Form20DirectorResolution :data="getCompanyDirectors ? getCompanyDirectors.data : null" badge="Current Company Directors"/>
        </b-col>
        <b-col>
          <Form20DirectorResolution :data="data" badge="New Company Directors"/>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import Form20DirectorResolution from "@/views/home/services/continuous-filing/task/forms/Form20DirectorResolution";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ChangeOfDirectors",
  components: { Form20DirectorResolution },
  props:{
    data:Object,
    brn:String
  },
  mounted() {
    this.fetchCompanyDirectors(this.brn)
  },
  methods:{
    ...mapActions(["fetchCompanyDirectors"]),
  },
  computed:{
    ...mapGetters(["getCompanyDirectors"])
  }
};
</script>

<style scoped>
th, td{
  font-size: 12px;
}

.pdf{
  width: 100%;
  height: 800px;
  overflow-x: auto;
  border:1px solid #b1b1b1;
}
</style>